var DataItem = /*#__PURE__*/function () {
  function DataItem(data) {
    if (data === void 0) {
      data = undefined;
    }

    this.data = data;
  }

  var _proto = DataItem.prototype;

  _proto.isActive = function isActive() {
    return true;
  };

  _proto["export"] = function _export() {
    return this.data;
  };

  return DataItem;
}();

export { DataItem as default };